import React, { useEffect, useState } from 'react';

import { Color } from '../../enums';
import { UseState } from '../../types';

import { IconSVG } from './icon.styled';
import { IcoMoonSelectionJson, IcoMoonSelectionJsonAttr, IcoMoonSelectionJsonIconObject, IconProps } from './icon.types';
import config from './resources/selection.json';
import icons from './resources/symbol-defs.svg';

export const Icon: React.FC<IconProps> = (props: IconProps): JSX.Element => {
  const { name, color = Color.Black, size, className }: IconProps = props;
  const iconsConfig: IcoMoonSelectionJsonIconObject[] = (config as IcoMoonSelectionJson).icons;
  const iconObject: IcoMoonSelectionJsonIconObject | undefined = iconsConfig.find(
    (icon: IcoMoonSelectionJsonIconObject) => icon.properties.name === name
  );
  const isIconWithStroke: boolean = !!iconObject?.attrs?.length;
  const isIconWithFill: boolean = !iconObject?.attrs?.length || iconObject?.attrs?.every(
    (attr: IcoMoonSelectionJsonAttr) => attr?.fill !== 'none'
  );
  const [iconSymbolSource, setIconSymbolSource]: UseState<string> = useState<string>('');
  const [defsIconsSource, setDefsIconsSource]: UseState<Element | null> = useState<Element | null>(null);

  // HOTFIX FOR SAFARI, DO NOT TREAT THIS AS A GOOD PATTERN CODE
  useEffect(
    (): void => {
      try {
        void fetch(icons)
          .then((response: Response): Promise<string> => response.text())
          .then((text: string) => {
            const iconsSource: Document = new DOMParser().parseFromString(text, 'text/html');
            const svgElement: ChildNode | null = iconsSource.body.firstChild;
            if (svgElement) {
              setDefsIconsSource((svgElement as HTMLElement).firstElementChild);
            }
          });
      // eslint-disable-next-line no-empty
      } catch (e) {}
    },
    []
  );

  // HOTFIX FOR SAFARI, DO NOT TREAT THIS AS A GOOD PATTERN CODE
  useEffect(
    (): void => {
      try {
        if (defsIconsSource) {
          const singleIconSource: Element | null = (defsIconsSource as HTMLElement).querySelector(`#icon-${name}`);
          setIconSymbolSource(singleIconSource?.outerHTML ?? '');
        }
      // eslint-disable-next-line no-empty
      } catch (e) {}
    },
    [name, defsIconsSource]
  );

  return (
    <IconSVG
      className={`icon-${name} ${className ?? ''}`}
      $fill={isIconWithFill ? color : undefined}
      $color={isIconWithStroke ? color : undefined}
      $size={size}
    >
      <defs dangerouslySetInnerHTML={{ __html: iconSymbolSource }} /> 
      <use href={`#icon-${name}`} />
    </IconSVG>
  );
};
